var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitlelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 37,
    viewBox: "0 0 155 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9483_21846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7478 16.3232V28.1013H41.3644V17.1667C41.3644 14.7886 39.9623 13.6739 38.2395 13.6739C36.2654 13.6739 34.903 14.9043 34.903 17.6264V28.1013H29.5195V8.92107H34.903V10.727C35.8752 9.30805 37.6674 8.38525 40.0351 8.38525C43.6593 8.38525 46.7445 11.147 46.7445 16.3266L46.7478 16.3232Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7945 9.3744L61.3099 27.8038C59.187 33.8466 55.814 36.2412 50.5067 35.9733V30.6515C53.162 30.6515 54.412 29.8147 55.2453 27.4962L47.6992 9.37109H53.9556L58.1652 21.0003L61.7299 9.37109H67.7978L67.7945 9.3744Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9248 1.48242V28.5477H81.5876V26.7286C80.4137 28.1971 78.6711 29.0868 76.2869 29.0868C71.6276 29.0868 67.7852 24.6382 67.7852 18.8799C67.7852 13.1215 71.6276 8.67292 76.2869 8.67292C78.6711 8.67292 80.4137 9.56264 81.5876 11.0312V1.48242H86.9248ZM81.5909 18.8832C81.5909 15.9825 79.8119 14.1634 77.355 14.1634C74.898 14.1634 73.1223 15.9825 73.1223 18.8832C73.1223 21.7838 74.9013 23.603 77.355 23.603C79.8086 23.603 81.5909 21.7838 81.5909 18.8832Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7539 18.7343C90.7539 12.89 95.0163 8.38184 100.324 8.38184C105.631 8.38184 109.894 12.8933 109.894 18.7343C109.894 24.5753 105.631 29.0868 100.324 29.0868C95.0163 29.0868 90.7539 24.5753 90.7539 18.7343ZM104.474 18.7343C104.474 15.9494 102.668 14.1071 100.32 14.1071C97.9726 14.1071 96.1671 15.9527 96.1671 18.7343C96.1671 21.5159 97.9726 23.3615 100.32 23.3615C102.668 23.3615 104.474 21.5192 104.474 18.7343Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.991 16.3232V28.1013H124.611V17.1667C124.611 14.7886 123.209 13.6739 121.486 13.6739C119.512 13.6739 118.15 14.9043 118.15 17.6264V28.1013H112.77V8.92107H118.15V10.727C119.122 9.30805 120.914 8.38525 123.282 8.38525C126.906 8.38525 129.991 11.147 129.991 16.3266V16.3232Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.127 23.8313C144.635 23.8313 145.924 23.2028 146.659 22.3429L151.076 25.0484C149.271 27.7143 146.549 29.0902 143.054 29.0902C136.761 29.0902 132.859 24.5788 132.859 18.7377C132.859 12.8967 136.834 8.38525 142.651 8.38525C148.021 8.38525 151.999 12.8173 151.999 18.7377C151.999 19.5613 151.926 20.3452 151.781 21.0927H138.716C139.417 23.1301 141.106 23.8379 143.134 23.8379L143.127 23.8313ZM146.513 16.697C145.924 14.4214 144.268 13.5979 142.611 13.5979C140.511 13.5979 139.112 14.6993 138.6 16.697H146.513Z",
    fill: "#00CB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39996 8.99707V21.506L3 18.3871V12.4964C3 12.2616 3.12566 12.04 3.33068 11.9242L8.39996 9.00038V8.99707Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7717 8.67318L8.90234 14.9409V8.70625L8.96517 8.66987L14.0378 5.74604C14.2428 5.62697 14.4941 5.62697 14.6991 5.74604L19.7717 8.67318Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7206 12.4898V18.3507L14.8711 12.0829L20.2777 8.96729L20.3207 8.99044L25.3899 11.9176C25.595 12.0366 25.7206 12.2549 25.7206 12.4898Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8171 22.333V28.5676L19.7212 28.6239L14.6486 31.5477C14.4436 31.6668 14.1923 31.6668 13.9873 31.5477L8.91797 28.6206L19.8171 22.333Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7164 18.926V24.7836C25.7164 25.0217 25.5907 25.24 25.3857 25.3558L20.3164 28.2763V15.8037L25.2204 18.6349L25.7164 18.9227V18.926Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8165 25.2137L8.90259 28.0482L8.4165 28.3293L8.39996 28.3227L3.33068 25.3956C3.12566 25.2765 3 25.0582 3 24.8234V18.9658L13.8165 25.2137Z",
    fill: "#2396E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7164 25.7432V28.8026C25.7164 29.0407 25.5907 29.259 25.3857 29.3748L21.3084 31.7264C20.8686 31.9811 20.3164 31.6636 20.3164 31.1542V28.8588L25.7164 25.7432Z",
    fill: "#2396E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9483_21846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 34.5104,
    fill: "white",
    transform: "translate(3 1.48242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitlelogo);
export default __webpack_public_path__ + "static/media/titlelogo.a87b013d93c134c0b59bb3a323588188.svg";
export { ForwardRef as ReactComponent };